// noinspection JSUnusedGlobalSymbols
export default {

    all: state => Object.values(state.entities),

    allByIsArchived: (state, getters) => isArchived => {
        return getters['all'].filter(product => product.isArchived === isArchived)
    },

    allByStatus: (state, getters) => status => {
        return getters['all'].filter(product => product.status === status && !product.isArchived)
    },

    byId: state => id => {
        return state.entities[id]
    },

    counts: state => state.counts,

    draft: state => state.draft

}


